<template>
    <v-app>
        <router-view></router-view>
    </v-app>
</template>

<script>
export default {
    name: 'app',
    computed: {
        alert () {
            return this.$store.state.alert
        }
    },
    watch:{
        $route (_to, _from){
            // clear alert on location change
            this.$store.dispatch('alert/clear');
        }
    },
};
</script>
